import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FurySharedModule } from 'src/@fury/fury-shared.module';
import { ListModule } from 'src/@fury/shared/list/list.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CKEditorModule } from 'ng2-ckeditor';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatTableModule } from '@angular/material/table';
import { MatMenuModule } from '@angular/material/menu';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { NgxPaginationModule } from 'ngx-pagination';
import {MatSelectModule} from '@angular/material/select';

import { AffiliatesRoutingModule } from './affiliates-routing.module';
import { AffiliatesComponent } from './affiliates.component';
import { PendingAffliatesListComponent } from './pending-affliates-list/pending-affliates-list.component';
import { ApprovedAffliatesListComponent } from './approved-affliates-list/approved-affliates-list.component';
import { DeclinedAffliatesListComponent } from './declined-affliates-list/declined-affliates-list.component';


@NgModule({
  declarations: [
    AffiliatesComponent,
    PendingAffliatesListComponent,
    ApprovedAffliatesListComponent,
    DeclinedAffliatesListComponent
  ],
  imports: [
    CommonModule,
    AffiliatesRoutingModule,
    FurySharedModule,
    ListModule,
    FlexLayoutModule,
    CKEditorModule,
    MatIconModule,
    MatPaginatorModule,
    SharedModule,
    MatTableModule,
    MatMenuModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxPaginationModule,
    MatSelectModule
  ]
})
export class AffiliatesModule { }
